var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          staticClass: "feedback-modal",
          attrs: {
            name: "feedback",
            adaptive: true,
            scrollable: true,
            reset: true,
            width: "40%",
            height: "auto",
          },
        },
        [
          _c("div", { staticClass: "modal__content" }, [
            _c("div", { staticClass: "modal__header" }, [
              _vm._v(
                "\n                Lähetä palautetta tai idea\n            "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "feedback-form" }, [
              _c(
                "form",
                {
                  staticClass: "default",
                  attrs: { method: "post", name: "send-feedback" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.sendFeedback.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "form-group--error": _vm.$v.name.$error },
                    },
                    [
                      _c("label", [_vm._v("Nimesi")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.$v.name.$model,
                            expression: "$v.name.$model",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { type: "text", placeholder: "Nimesi" },
                        domProps: { value: _vm.$v.name.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.name,
                              "$model",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "form-group--error": _vm.$v.email.$error },
                    },
                    [
                      _c("label", [_vm._v("Sähköpostiosoitteesi")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.lazy",
                            value: _vm.$v.email.$model,
                            expression: "$v.email.$model",
                            modifiers: { lazy: true },
                          },
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "Sähköpostiosoitteesi",
                        },
                        domProps: { value: _vm.$v.email.$model },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.$v.email,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "form-group--error": _vm.$v.subject.$error },
                    },
                    [
                      _c("label", [_vm._v("Aihe")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.$v.subject.$model,
                            expression: "$v.subject.$model",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "Palautteesi / viestisi aihe",
                        },
                        domProps: { value: _vm.$v.subject.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.subject,
                              "$model",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "form-group--error": _vm.$v.message.$error },
                    },
                    [
                      _c("label", [_vm._v("Viestisi")]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.message.$model,
                            expression: "$v.message.$model",
                          },
                        ],
                        attrs: { rows: "12", id: "message" },
                        domProps: { value: _vm.$v.message.$model },
                        on: {
                          focusin: _vm.removeMessagePlaceholder,
                          focusout: _vm.addMessagePlaceholder,
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.message,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal__footer text-right" }, [
              _c(
                "span",
                {
                  staticClass: "btn btn--hollow btn--small",
                  on: { click: _vm.closeModal },
                },
                [_vm._v("Peruuta")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--call-to-action btn--small",
                  on: { click: _vm.sendFeedback },
                },
                [_vm._v("\n                    Lähetä\n                ")]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-footer" }, [
        _c("a", { on: { click: _vm.openModal } }, [
          _vm._v("Lähetä palautetta tai idea "),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }